module.exports = __webpack_public_path__ + "static/media/bad.562dbbcd.png";